// si canvia algun camp revisar i actualitzar, per exemple, RealEstateEditor.vue funció "set_realestate_property_type"
export default [
    {
        bde_code: 'V93',
        name_es: 'V93 - Vivienda protegida',
        name_ca: 'V93 - Habitatge protegit',
        name_en: 'V93 - State-subsidized housing',
        lifespan: 100
    },
    {
        bde_code: 'V94',
        name_es: 'V94 - Vivienda libre de primera residencia',
        name_ca: 'V94 - Habitatge lliure de primera residència',
        name_en: 'V94 - Primary residence free-market housing',
        lifespan: 100
    },
    {
        bde_code: 'V95',
        name_es: 'V95 - Vivienda libre de segunda residencia',
        name_ca: 'V95 - Habitatge lliure de segona residència',
        name_en: 'V95 - Secondary residence free-market housing',
        lifespan: 100
    },
    {
        bde_code: 'V96',
        name_es: 'V96 - Oficinas',
        name_ca: 'V96 - Oficines',
        name_en: 'V96 - Offices',
        lifespan: 75
    },
    {
        bde_code: 'V97',
        name_es: 'V97 - Locales comerciales',
        name_ca: 'V97 - Locals comercials',
        name_en: 'V97 - Retail',
        lifespan: 50
    },
    {
        bde_code: 'V98',
        name_es: 'V98 - Plazas de garaje',
        name_ca: 'V98 - Places d\'aparcament',
        name_en: 'V98 - Parking spaces',
        lifespan: 100
    },
    {
        bde_code: 'V99',
        name_es: 'V99 - Trasteros',
        name_ca: 'V99 - Trasters',
        name_en: 'V99 - Storage rooms',
        lifespan: 100
    },
    {
        bde_code: 'VA1',
        name_es: 'VA1 - Hoteles',
        name_ca: 'VA1 - Hotels',
        name_en: 'VA1 - Hotels',
        lifespan: 50
    },
    {
        bde_code: 'VA2',
        name_es: 'VA2 - Residencias de estudiantes',
        name_ca: 'VA2 - Residències d\'estudiants',
        name_en: 'VA2 - Students residencew',
        lifespan: 100
    },
    {
        bde_code: 'VA3',
        name_es: 'VA3 - Resto de los edificios',
        name_ca: 'VA3 - Altres edificis',
        name_en: 'VA3 - Other buildings',
        lifespan: 50
    },
    {
        bde_code: 'VA2',
        name_es: 'VA2 - Residencias de la tercera edad',
        name_ca: 'VA2 - Residències geriàtriques',
        name_en: 'VA2 - Elderly homes',
        lifespan: 100
    }
]



// WEBPACK FOOTER //
// ./src/options/asset_types.js